import React from "react";
import { useNavigate } from "react-router-dom";

import Building from "../../Assets/homeimgs/BuildingArchitecture.jpg";
import Highways from "../../Assets/homeimgs/Highways.jpg";
import Bridges from "../../Assets/homeimgs/Bridges.jpg";
import Railway from "../../Assets/homeimgs/Railway.jpeg";
import Water from "../../Assets/homeimgs/WaterResourses.jpg";
import Survey from "../../Assets/homeimgs/Survey.jpg";

const sectorsData = [
  {
    name: "Building & Architecture",
    image: Building,
    about:
      "We have successfully delivered township planning projects and have contributed significantly in urban planning.",
    about2:
      "We are generally carry out design of Residential building, Commercial building,Veterinary building, School building PHC & CHC building etc.We ",
    about3:
      "prioritize climate-responsive, innovative architecture that maximizes open space. Our commitment extends to designing structurally and functionally resilient units that enhance safety and minimize risks to human life and infrastructure during disasters.",
  },
  {
    name: "Road-Sector",
    image: Highways,
    about:
      "Our firm has developed proficiency in planning & design, rehabilitation, and strengthening of all types of roads.",
    highwayTypes: {
      "National Highway":
        "National highways form the backbone of a country's transport network, connecting cities, states, and industrial hubs. Managed by NHAI, they drive economic growth and trade. Projects like the Golden Quadrilateral and Bharatmala Pariyojana enhance infrastructure and reduce travel time. With smart technology, eco-friendly construction, and expansions, India aims to strengthen connectivity and boost nationwide development.",
      "State Highway":
        "State highways are vital for regional connectivity, linking districts, cities, and major roads. Managed by state governments, they support economic growth and trade. Projects enhancing road widening, maintenance, and modernization improve infrastructure and reduce travel time. With smart technology, eco-friendly construction, and expansions, states aim to strengthen connectivity and boost overall development.",
      "ODR Highway":
        "Other District Roads (ODR) are essential for rural connectivity, linking villages, towns, and local markets to major highways. Managed by district authorities, they support regional trade and mobility. Projects focused on upgradation, maintenance, and sustainability enhance infrastructure and accessibility. With smart planning and expansions, ODR highways improve connectivity and drive local economic growth.",
    },
  },
  {
    name: "Bridges",
    image: Bridges,
    about:
      "Bridges, Flyovers, and ROB/RUB structures are integral to infrastructure development and urban planning.",
    about2:
      "Bridges, flyovers, road over bridges, interchanges, and ROB/RUB structures are vital components of road and railway infrastructure, playing a key role in urban development.",
    about3:
      "We have successfully designed and overseen the construction of numerous bridges nationwide, including key projects exceeding 2,500 meters. These feature well/pile foundations and advanced superstructures such as segmental post-tensioned box girders, pre-tensioned girders, RCC decks, prestressed girders, steel girders with RCC decks, and steel through girders.",
  },
  {
    name: "Railway",
    image: Railway,
    about:
      "We have designed the implementation of ballast-less tracks and track laying in tunnels.",
    about2:
      "The Government of India prioritizes railway capacity enhancement through network expansion, dedicated freight corridors, additional tracks, and gauge conversion. These initiatives aim to create a sustainable, cost-effective, efficient, and safe railway infrastructure, ensuring reliability and environmental sustainability while strengthening the nation’s transportation network.",
    about3:
      "Our expertise spans over 10,000 km of railway track design, construction, rehabilitation, yard capacity enhancement, dedicated industrial corridors, and railway infrastructure development for industries, along with railway operations and maintenance services.",
  },
  {
    name: "Water Resources",
    image: Water,
    about:
      "We specialize in the planning and design of water retention structures and water resource management strategies.",
    about2:
      "Water is becoming an increasingly valuable resource, making its management a critical challenge for engineers. Essential for both life and industry, significant river discharge is lost to the sea. To optimize utilization, efforts are focused on water retention through multiple barrages and weirs along river pathways, ensuring sustainable resource management.",
    about3:
      "We assess sub-surface water availability near rivers to explore the potential for water extraction through radial wells. Additionally, we conduct drawdown tests to evaluate borewell infiltration capacity, ensuring efficient groundwater utilization and sustainable water resource management.",
  },
  {
    name: "Survey",
    image: Survey,
    about:
      "Our team provides digital mapping, land assessment, and survey solutions for various projects.",
    about2:
      "A topographic survey is essential for any infrastructure project, as its precision forms the foundation for effective engineering design.",
    about3:
      "Our firm excels in topographical surveys, having conducted extensive surveys across India using advanced technology and software. We have also leveraged LiDAR technology mounted on vehicles to survey challenging terrains with high accuracy. Our survey expertise covers a wide range of projects, including land subdivision, mining exploration, tunnel construction, major infrastructure, and linear project surveys for roads and railways. We also specialize in forest surveying and excel in data transfer, processing, and interpretation with precision and efficiency.",
  },
];

const OurCoreSectors = () => {
  const navigate = useNavigate();

  const handleNavigate = (sector) => {
    navigate("/sectors", { state: { sector } }); // Pass sector data via React Router
  };

  return (
    <div className="py-8 md:mx-16 mx-6 mt-5 md:mt-10">
      <div className="lg:flex justify-between" data-aos="zoom-in-down">
        <div className="items-start" data-aos="fade-down-left">
          <h1 className="text-3xl lg:text-5xl font-semibold mb-4">
            Our Core Sectors
          </h1>
          <p className="text-gray-600 text-base md:text-md lg:text-xl mb-8">
            "Our Core Sectors include engineering, infrastructure, design
            consultancy, construction, and project management expertise."
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 md:mt-3 lg:mt-0">
        {sectorsData.map((sector, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer"
            data-aos="flip-left"
            onClick={() => handleNavigate(sector)} // Navigate on click
          >
            <img
              src={sector.image}
              alt={sector.name}
              className="w-full h-72 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-bold mb-2">{sector.name}</h2>
              <p className="text-gray-600 text-base tracking-wide mb-3">
                {sector.about}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurCoreSectors;
